import LazyLoad from 'vanilla-lazyload';

const LAZY_LOADING_VERTICAL_OFFSET = 256;
var SWIPER_SCRIPTS_LOADED = false;
var lazyLoadInstance = null;

$(function() {
    var callback_error = function(element) {
        $(element).on('error', function() {
            var image = $(this).attr("srcset");
            if ($(this).siblings("source").attr("srcset") != image) {
                $(this).siblings("source").attr("srcset", image);
                $(this).removeClass("error");
            } else {
                $(this).parent().parent().removeClass("img-placeholder");
                $(this).addClass("error");
            }
        });
        element.src = $(this).attr("srcset");
    }

    lazyLoadInstance = new LazyLoad({
        elements_selector: '[loading="lazy"]',
        use_native: true,
        callback_error: callback_error
    });

});

export function initLazyLoad(selector, updateLazyLoad = false, offset = LAZY_LOADING_VERTICAL_OFFSET, callback) {
    if (updateLazyLoad) {
        lazyLoadInstance.update();
    }

    var lazySelector = [].slice.call(document.querySelectorAll(selector));

    if ("IntersectionObserver" in window) {
        switch (selector) {
            case '.lazyBackground':
                lazyloadBgImagesWith(lazySelector, offset);
                break;
            case 'video.lazy':
                lazyloadVideosWith(lazySelector, offset);
                break;
            case 'img.lazy':
                lazyloadImagesWith(lazySelector, offset);
                break;
            case '.anim-trigger':
                lazyloadAnimateGridWith(lazySelector, offset);
                break;
            case '.swiper-container':
                var facultyUrl = $('#faculty-category');
                var teacherDetailUrl = $('#teacher-detail');
                if (facultyUrl.length > 0 || teacherDetailUrl.length > 0) {
                    lazySelector = [];
                }
                //console.log("Lazy Selector", lazySelector);
                lazyloadSwiperWith(lazySelector, offset);
                break;
            default:
                lazyloadBgImagesWith(lazySelector, offset, callback);
                break;
        }
    } else {
        var lazyThrottleTimeout;
        var active = false;
        switch (lazySelector) {
            case '.lazyBackground':
                lazyloadBgImagesWithout(lazySelector, lazyThrottleTimeout, offset);
                lazyAddEventListener(lazyloadBgImagesWithout);
                break;
            case 'video.lazy':
                lazyloadVideosWithout(lazySelector, lazyThrottleTimeout, offset);
                lazyAddEventListener(lazyloadVideosWithout);
                break;
            case 'img.lazy':
                lazyloadImagesWithout(lazySelector, active, offset);
                lazyAddEventListener(lazyloadImagesWithout);
                break;
            case '.anim-trigger':
                lazyloadAnimateGridWithout(lazySelector, lazyThrottleTimeout);
                lazyAddEventListener(lazyloadAnimateGridWithout);
                break;
            case '.swiper-container':
                var facultyUrl = $('#faculty-category');
                var teacherDetailUrl = $('#teacher-detail');
                if (facultyUrl.length > 0 || teacherDetailUrl.length > 0) {
                    lazySelector = [];
                }
                lazyloadSwiperWithout(lazySelector, lazyThrottleTimeout, offset);
                lazyAddEventListener(lazyloadSwiperWithout);
                break;
        }
    }
}

function lazyloadBgImagesWith(lazySelector, offset, callback) {
    var imageObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var image = entry.target;
                image.classList.remove("lazyBackground");
                if (typeof callback === "function") {
                    image.classList.remove("lazyFlag");
                    callback();
                }
                imageObserver.unobserve(image);
            }
        });
    }, {
        rootMargin: setRootMargin(offset)
    });
    observeForeach(lazySelector, imageObserver);
}

function lazyloadVideosWith(lazySelector, offset) {
    var lazyVideoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(video) {
            if (video.isIntersecting) {
                for (var source in video.target.children) {
                    var videoSource = video.target.children[source];
                    if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                        videoSource.src = videoSource.dataset.src;
                    }
                }
                video.target.load();
                video.target.classList.remove("lazy");
                lazyVideoObserver.unobserve(video.target);
            }
        });
    }, {
        rootMargin: setRootMargin(offset)
    });
    observeForeach(lazySelector, lazyVideoObserver);
}

function lazyloadImagesWith(lazySelector, offset) {
    var lazyImageObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var lazyImage = entry.target;
                lazyImage.src = lazyImage.dataset.src;
                lazyImage.classList.remove("lazy");
                lazyImageObserver.unobserve(lazyImage);
            }
        });
    }, {
        rootMargin: setRootMargin(offset)
    });
    observeForeach(lazySelector, lazyImageObserver);
}

function lazyloadAnimateGridWith(lazySelector, offset) {
    var animTriggerObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var target = entry.target;
                target.classList.add("animated");
                target.classList.remove("anim-trigger");
                animTriggerObserver.unobserve(target);
            }
        });
    }, {
        rootMargin: setRootMargin(offset)
    });
    observeForeach(lazySelector, animTriggerObserver);
}

function lazyloadSwiperWith(lazySelector, offset) {
    var swiperObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var target = entry.target;
                var swiper = target.swiper;

                if (!SWIPER_SCRIPTS_LOADED) {
                    tech.core.loadScripts([
                        "/js/swiper.min.js",
                        "/js/swiper-init.js"
                    ])
                    SWIPER_SCRIPTS_LOADED = true;
                }

                swiperObserver.unobserve(target);
            }
        });
    }, {
        rootMargin: setRootMargin(offset)
    });
    observeForeach(lazySelector, swiperObserver);
}

function lazyloadBgImagesWithout(lazySelector, lazyloadThrottleTimeout, offset) {
    if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
    }

    lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazySelector.forEach(function(img) {
            if (img.offsetTop - offset < (window.innerHeight + scrollTop)) {
                img.src = img.dataset.src;
                img.classList.remove('lazyBackground');
            }
        });
        lazyRemoveEventListener(lazySelector.length, lazyloadBgImagesWithout);
    }, 20);
}

function lazyloadVideosWithout(lazySelector, lazyloadThrottleTimeout, offset) {
    if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
    }

    lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazySelector.forEach(function(video) {
            if (video.offsetTop - offset < (window.innerHeight + scrollTop)) {
                for (var source in video.target.children) {
                    var videoSource = video.target.children[source];
                    if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                        videoSource.src = videoSource.dataset.src;
                    }
                }
                video.target.load();
                video.target.classList.remove("lazy");
            }
        });
        lazyRemoveEventListener(lazySelector.length, lazyloadVideosWithout);
    }, 20);
}

function lazyloadImagesWithout(lazySelector, active, offset) {
    if (active === false) {
        active = true;

        setTimeout(function() {
            lazySelector.forEach(function(lazyImage) {
                if ((lazyImage.getBoundingClientRect().top - offset <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.srcset = lazyImage.dataset.srcset;
                    lazyImage.classList.remove("lazy");

                    lazyImages = lazySelector.filter(function(image) {
                        return image !== lazyImage;
                    });
                    lazyRemoveEventListener(lazySelector.length, lazyloadImagesWithout);
                }
            });

            active = false;
        }, 200);
    }
}

function lazyloadAnimateGridWithout(lazySelector, lazyloadThrottleTimeout) {
    if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
    }

    lazyloadThrottleTimeout = setTimeout(function() {
        lazySelector.forEach(function(target) {
            target.classList.add("animated");
            target.classList.remove("anim-trigger");
        });
        lazyRemoveEventListener(lazySelector.length, lazyloadAnimateGridWithout);
    }, 20);
}

function lazyloadSwiperWithout(lazySelector, lazyloadThrottleTimeout, offset) {
    if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
    }

    lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazySelector.forEach(function(swiperWrap) {
            if (swiperWrap.offsetTop - offset < (window.innerHeight + scrollTop)) {
                //Load slider page
                var swiper = swiperWrap.swiper;
                tech.core.loadScripts([
                    "/js/swiper.min.js",
                    "/js/swiper-init.js"
                ])
            }
        });
        lazyRemoveEventListener(lazySelector.length, lazyloadSwiperWithout);
    }, 20);
}

function lazyRemoveEventListener(selectorLength, selectorFunction) {
    if (selectorLength === 0) {
        document.removeEventListener("scroll", selectorFunction);
        window.removeEventListener("resize", selectorFunction);
        window.removeEventListener("orientationChange", selectorFunction);
    }
}

function lazyAddEventListener(selectorFunction) {
    document.addEventListener("scroll", selectorFunction);
    window.addEventListener("resize", selectorFunction);
    window.addEventListener("orientationChange", selectorFunction);
}

function observeForeach(lazySelector, selectorObserver) {
    lazySelector.forEach(function(element) {
        selectorObserver.observe(element);
    });
}

function setRootMargin(offset) {
    return "0px 0px " + offset + "px 0px";
}